import { colors, intl, ui } from '@beelday/common'
import styled from '@emotion/styled'
import { FC } from 'react'
import { use100vh } from 'react-div-100vh'
import { RoomContainer } from 'room/common/presentation/room-container'
import RoomHeader from 'room/common/presentation/room-header'

const Container = styled.div`
	flex: 1;
	display: flex;
	overflow: auto;
	padding: 24px;
`

const Card = styled.div`
	background: ${colors.white};
	border-radius: 20px;
	padding: 32px;
	max-width: 420px;
	width: 100%;
	margin: auto;
	display: flex;
	flex-direction: column;
	row-gap: 16px;
	text-align: center;
`

const Description = styled.p`
	margin: 0;
	color: ${colors.blackish};
	font-size: 16px;
	line-height: 24px;
`

/**
 * The trainer below 1024px. An in-person training is driven from the laptop
 * wired to the projector, and a trainer on a phone or tablet is not a thing
 * we intend to support (D11). Participants at these widths get
 * `room-trainee-in-person.mobile.tsx` instead. Deliberately not extended to
 * online trainings, which work at these widths today.
 */
export const TooSmallForInPerson: FC = () => {
	const containerHeight = use100vh()

	return (
		<RoomContainer
			style={{
				height: `${containerHeight}px`,
			}}
			data-testid="in_person.too_small"
		>
			<RoomHeader />
			<Container>
				<Card>
					<ui.H2>
						<intl.Translate>in_person.too_small.trainer.title</intl.Translate>
					</ui.H2>
					<Description>
						<intl.Translate>
							in_person.too_small.trainer.description
						</intl.Translate>
					</Description>
				</Card>
			</Container>
			<ui.BeeldayLogoAbsoluteBottom />
		</RoomContainer>
	)
}

export default TooSmallForInPerson
